import { render, staticRenderFns } from "./actFemaleMain.vue?vue&type=template&id=ba622aa0&scoped=true"
import script from "./actFemaleMain.vue?vue&type=script&lang=js"
export * from "./actFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./actFemaleMain.vue?vue&type=style&index=0&id=ba622aa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba622aa0",
  null
  
)

export default component.exports